import { createAction, createReducer } from 'deox';

export interface SessionToken {
  token: string;
}

export const defaultState: SessionToken = {
  token: '',
};

export const setSessionToken = createAction(
  'SET_SESSION_TOKEN',
  resolve => (token: string) => resolve(cleanSessionToken(token)),
);

export const sessionTokenReducer = createReducer(defaultState, handleAction => [
  handleAction(setSessionToken, (state, { payload: token }) => {
    return {
      ...state,
      token,
    };
  }),
]);

export interface MountedState {
  sessionToken: ReturnType<typeof sessionTokenReducer>;
}

export const loadSessionTokenFromLocalStore = () => {
  try {
    return localStorage.getItem('sessionToken');
  } catch (err) {
    return undefined;
  }
};

export const saveSessionTokenToLocalStore = (sessionToken: string) => {
  try {
    localStorage.setItem('sessionToken', cleanSessionToken(sessionToken));
  } catch (err) {
    if (err.name === 'SecurityError') {
      console.error(
        'SecurityError: Not allowed to save session token to localStorage.',
      );
    } else {
      throw err;
    }
  }
};

export const selectSessionToken = (state: MountedState): SessionToken =>
  state.sessionToken;

const cleanSessionToken = (sessionToken: string): string => {
  return sessionToken ? sessionToken.replace('Bearer ', '') : '';
};

export default sessionTokenReducer;
